import { ImportJob } from './types';

type CreateWordPressImportJobParams = {
  stationId: string;
  userId: number;
};

export type CreateWordPressImportJobResponse = ImportJob;

export async function createWordPressImportJob({
  stationId,
  userId,
}: CreateWordPressImportJobParams): Promise<CreateWordPressImportJobResponse> {
  try {
    const response = await fetch(`/api/proxy/v3/wordpress/import_job`, {
      method: 'POST',
      headers: new Headers({ 'Content-type': 'application/json' }),
      body: JSON.stringify({ stationId, userId }),
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error('Unable to create WordPress import job');
  } catch (err) {
    throw new Error(err.message);
  }
}
